import { useIdentity } from '@office-start/identity-service';
import { useLocStrings } from '@office-start/loc-service';
import { useShellConfig } from '@office-start/shell-config-service';
import { HarmonyThemeId, HarmonyThemeMode, } from '@office-start/visual-types';
import { useMemo, useRef } from 'react';
import { logUserSettingsImpression } from '../util/userSettingsTelemetry';
import { useGetHarmonyTheme } from './useGetHarmonyTheme';
import { useUserSettingsCallbacks } from './useUserSettingsCallbacks';
export var useUserSettingsConfig = function () {
    var harmonyTheme = useGetHarmonyTheme();
    var identity = useIdentity().data;
    var locStrings = useLocStrings().data;
    var shellConfig = useShellConfig().data;
    var callbacks = useUserSettingsCallbacks();
    var isPaintMarkerRecorded = useRef(false);
    // ToDo: How to handle when in system High Contrast for Web and HWA System settings
    return useMemo(function () {
        var _a, _b;
        if (!callbacks || !identity || !locStrings || !shellConfig) {
            return undefined;
        }
        // Log UserSettings impression
        if (!isPaintMarkerRecorded.current) {
            logUserSettingsImpression();
            isPaintMarkerRecorded.current = true;
        }
        return {
            callbacks: callbacks,
            id: ((_a = harmonyTheme === null || harmonyTheme === void 0 ? void 0 : harmonyTheme.result) === null || _a === void 0 ? void 0 : _a.id) || HarmonyThemeId.Office,
            isMSA: identity.isMsa,
            mode: ((_b = harmonyTheme === null || harmonyTheme === void 0 ? void 0 : harmonyTheme.result) === null || _b === void 0 ? void 0 : _b.mode) || HarmonyThemeMode.Light,
            userSettingsStrings: locStrings.userSettingsResources,
            thirdPartyNoticeLinkText: locStrings.shellResources.thirdPartyNoticeLinkText,
            thirdPartyNoticeUrl: shellConfig.thirdPartyNoticeUrl,
        };
    }, [callbacks, harmonyTheme, identity, locStrings, shellConfig]);
};
//# sourceMappingURL=useUserSettingsConfig.js.map